"use strict";

exports.__esModule = true;
exports.DeviceConnectivitySubscription = DeviceConnectivitySubscription;
var _react = _interopRequireDefault(require("react"));
var _RealtimeConnection = require("../../API/RealtimeConnection");
var _excluded = ["heartbeatName", "entity", "topicArgs", "onData"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function defaultOnData() {}
function DeviceConnectivitySubscription(_ref) {
  var heartbeatName = _ref.heartbeatName,
    entity = _ref.entity,
    topicArgs = _ref.topicArgs,
    _ref$onData = _ref.onData,
    onData = _ref$onData === void 0 ? defaultOnData : _ref$onData,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_RealtimeConnection.RealtimeDataSubscription, _extends({
    params: ["connectivity", Object.assign({
      entity: Object.assign({}, entity, {
        name: heartbeatName
      })
    }, topicArgs)],
    onData: onData
  }, extra));
}